/** KAN-810: pill with the lead temperature label; nothing for an empty or unknown level. */
import { LEAD_TEMPERATURE_LABELS, isLeadTemperatureLevel, leadTemperatureStyle } from '@/lib/leadTemperature';

interface LeadTemperatureBadgeProps {
  level: string | null | undefined;
  className?: string;
  /** KAN-819: tooltip (who set the level and why). */
  title?: string;
}

export function LeadTemperatureBadge({ level, className = '', title }: LeadTemperatureBadgeProps) {
  const style = leadTemperatureStyle(level);
  if (!style || !isLeadTemperatureLevel(level)) return null;
  return (
    <span
      data-testid="lead-temperature-badge"
      title={title || undefined}
      className={`inline-flex shrink-0 items-center rounded-full px-2 py-0.5 text-xs font-medium ${style.pill} ${className}`}
    >
      {LEAD_TEMPERATURE_LABELS[level]}
    </span>
  );
}
